export default {
  sm: '120%',
  md: '133%',
  lg: '150%'
}
